export default function formatDate(str) {
  const date = new Date(str);

  return date.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    timeZone: "America/Cuiaba",
  });
}
